<template>
  <tr>
    <th>{{ sell.user.name }}</th>
    <th>{{ sell.course.name }}</th>
    <td>{{ sell.buyed_at }}</td>
    <td>{{ sell.value | formatMoney }}</td>
    <td>{{ paymentToText( sell.payment_form ) }}</td>
    <td>{{ sell.quotas }}x</td>
    <td>{{ statusToText( sell.status_payment ) }}</td>
    <td>
      <select v-model="sell.is_accessable" @change="changeCourseAccess" class="form-control form-control-sm custom-select custom-select-sm">
        <option value="1" >Sim</option>
        <option value="0" >Não</option>
      </select>
    </td>
    <td>
      <!-- <a href="#" @click.prevent="changeCourse" class="btn btn-sm btn-">Salvar</a> -->
    </td>
  </tr>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    sell: {
      required: true
    }
  },
  methods: {
    boolToText: ( value ) => { return value ? 'Sim' : 'Não' },
    paymentToText: ( value ) => { return value === 'blt' ? 'Boleto' : 'Cartão de Crédito' },
    statusToText: ( value ) => {
      if ( value === 'P' )
        return 'Processando'
      else if ( value === 'W' )
        return 'Aguardando Confirmação'
      else if ( value === 'S' )
        return 'Sucesso'
      else if ( value === 'E' )
        return 'Erro'
      else if ( value === 'C' )
        return 'Cancelado'
      // P - Processing // W - Wating // S - Success // E - Error
    },
    changeCourseAccess: function ( e ) {
      Axios.post('/teacher/my/courses/sells/change', {
        id: this.sell.id,
        is_accessable: e.target.value
      })
        .catch( err => {
          console.error( err )
        })
      // /my/courses/sells/change
    }
  }
}
</script>

<style>

</style>
